import { useState } from 'react';
import { getApiErrorMessage, postEmail } from '../services/emailApi';
import { useAlert } from '../context/AlertContext';

const useSendCashbackFeedback = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(false);
  const { showAlert } = useAlert();

  const sendFeedback = async (data) => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      const res = await postEmail('/feedback/cashback', data);
      showAlert(res.data.message, "success");
      setResponse(res.data.message);
    } catch (err) {
      const message = getApiErrorMessage(err, 'Erro ao enviar feedback');
      setError(message);
      showAlert(message, "error");
    } finally {
      setLoading(false);
    }
  };

  return { sendFeedback, response, loading, error };
};

export default useSendCashbackFeedback;
